// extracted by mini-css-extract-plugin
module.exports = {"container":"SidePanel-module--container--Km0fd","container__hidden":"SidePanel-module--container__hidden--34xeM","close":"SidePanel-module--close--3xIfn"};